<div class="col-12">
    <div class="col-12">
        <app-shared-partner
            [formatType]="'BNTENNISTOOL02'"
            [position]="'FEDERATION'"
            [direction]="'horizontal'"
        ></app-shared-partner>
    </div>
</div>

<div class="page">
    <div class="row">
        <div class="col-12">
            <h1 class="page-title">{{ "PAGES.FEDERATION" | translate }}</h1>
        </div>
        <a
            *ngFor="let feds of registers"
            class="col-lg-6 mb-30 federation-link"
            [href]="feds.url_redirect"
            target="_blank"
            rel="nofollow noreferrer noopener"
        >
            <div class="federation">
                <div class="federation-image">
                    <img [src]="feds.url_avatar" [alt]="feds.descrica" />
                </div>
                <div class="col-12">
                    <h2 class="federation-title">
                        {{ feds.descricao }}
                    </h2>
                    <p>
                        <span class="label">{{ "GENERAL.PRESIDENT" | translate }}</span
                        >{{ feds.presidente }}
                    </p>
                </div>
                <div class="col-md-6">
                    <p>
                        <span class="label">{{ "USER.CITY" | translate }}</span
                        >{{ feds.cidade }}
                    </p>
                </div>
                <div class="col-md-6">
                    <p>
                        <span class="label">{{ "USER.STATE" | translate }}</span
                        >{{ feds.uf }}
                    </p>
                </div>
                <div class="col-auto flex-grow-1">
                    <span class="label">{{ "USER.EMAIL" | translate }}</span>
                    <p>{{ feds.email }}</p>
                </div>
                <div class="col-md-6">
                    <span class="label">{{ "CONTACT-PAGE.PHONE" | translate }}</span>
                    <p>{{ feds.fone_contato }}</p>
                </div>

                <hr class="hr" />
            </div>
        </a>
    </div>
</div>
